import moment from 'moment-timezone';

const storeState = {
  company: null,
  closed: true,
  workingHours: null,
  remainingWorkingRanges: [],
  message: false,
  disableOrder: false,
  timeZone: 'Europe/Vienna',
};

const getHoursForDay = (workingHours, day) => {
  if (!workingHours) return [];
  const ranges = [];
  workingHours.forEach((range) => {
    if (range.day.toUpperCase() === day) {
      ranges.push(range);
    }
  });
  ranges.sort((a, b) => {
    if (a.startDate < b.startDate) return -1;
    return a.startDate > b.startDate ? 1 : 0;
  });
  return ranges;
};

const companyFromStorage = localStorage.company ? JSON.parse(localStorage.company) : null;
//
// let timeZone = moment.tz.guess();
//
// if (companyFromStorage) {
//   timeZone = companyFromStorage.address.country === 'UK' ? 'Europe/London' : 'Europe/Vienna';
// }

const formatWorkingHours = (workingHours) => {
  const zone = moment.tz.guess();
  const currentDate = moment().format('YYYY-MM-DD');
  return workingHours.map((range) => {
    const start = moment.tz(`${currentDate} ${range.start}`, 'YYYY-MM-DD HH:mm', storeState.timeZone).tz(zone);
    const end = moment.tz(`${currentDate} ${range.end}`, 'YYYY-MM-DD HH:mm', storeState.timeZone).tz(zone);
    return {
      start: start.format('HH:mm'),
      startDate: start.toISOString(),
      end: end.format('HH:mm'),
      endDate: end.toISOString(),
      day: range.day,
    };
  });
};

const days = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];

const langGet = () => {
  const fromUrl = window.location.pathname.split('/').filter(x => x !== '');
  const enIndex = fromUrl.indexOf('en');
  const deIndex = fromUrl.indexOf('de');
  if (enIndex !== -1) return 'en';
  if (deIndex !== -1) return 'de';

  if (storeState.company) {
    return storeState.company.defaultLanguage;
  }
  if (companyFromStorage) {
    return localStorage.getItem('lang') || companyFromStorage.defaultLanguage || 'en';
  }
  return localStorage.getItem('lang') || 'en';
};

const daysByLAng = {
  MONDAY: { en: 'Monday', de: 'Montag' },
  TUESDAY: { en: 'Tuesday', de: 'Dienstag' },
  WEDNESDAY: { en: 'Wednesday', de: 'Mittwoch' },
  THURSDAY: { en: 'Thursday', de: 'Donnerstag' },
  FRIDAY: { en: 'Friday', de: 'Freitag' },
  SATURDAY: { en: 'Saturday', de: 'Samstag' },
  SUNDAY: { en: 'Sunday', de: 'Sonntag' },
  PUBLICHOLIDAY: { en: 'Public Holiday', de: 'Feiertags' },
};

const close = () => {
  storeState.closed = true;
  storeState.disableOrder = false;
  storeState.message = false;
};

const checkWorkingHours = () => {
  if (storeState.company === null) {
    close();
    return;
  }
  const workingHours = storeState.workingHours;
  const curretnDay = moment().isoWeekday();
  const today = days[curretnDay - 1].toUpperCase();
  const tomorrow = days[curretnDay] ?
    days[curretnDay].toUpperCase() : days[0].toUpperCase();
  const ranges = getHoursForDay(workingHours, today);
  const ranges2 = getHoursForDay(workingHours, tomorrow);
  if (ranges.length === 0) {
    close();
    return;
  }
  const day1End = moment(ranges[ranges.length - 1].endDate);
  let canGoIntoNextDay;
  if (ranges2[0]) {
    const day2Start = moment(ranges2[0].startDate).add(1, 'day');
    const duration = moment.duration(day2Start.diff(day1End)).asMinutes();
    canGoIntoNextDay = duration === 1;
  } else {
    canGoIntoNextDay = false;
  }
  const now = moment();
  const remainingRanges = [];
  const [currentRange] = ranges.filter((range) => {
    const start = moment(range.startDate);
    const end = moment(range.endDate);
    if (start.isAfter(now)) {
      remainingRanges.push(range);
    }
    return now.isBetween(start, end);
  });

  if (!currentRange) {
    close();
    if (remainingRanges.length > 0) {
      storeState.remainingWorkingRanges = remainingRanges.sort((a, b) => {
        if (a.startDate < b.startDate) return -1;
        return a.startDate > b.startDate ? 1 : 0;
      });
    } else {
      storeState.remainingWorkingRanges = [];
    }
    return;
  }
  storeState.closed = false;
  const end = moment(currentRange.endDate);
  let difference = moment.duration(end.diff(moment())).asMinutes();
  if (canGoIntoNextDay) {
    const day2Start = moment(ranges2[0].startDate).add(1, 'day');
    const day2End = moment(ranges2[0].endDate).add(1, 'day');
    const minutesTomorrow = ranges2[0] ? moment.duration(day2End.diff(day2Start)).asMinutes() : 0;
    difference += minutesTomorrow;
  }
  const durationTo = storeState.company.deliverydurationTo;
  storeState.disableOrder = difference < durationTo;
  storeState.message = difference < durationTo + 15;
};

setInterval(() => {
  checkWorkingHours();
}, 60 * 1000);

const mutations = {
  setCompany(state, data) {
    // eslint-disable-next-line
    state.company = data;
    if (data) {
      // eslint-disable-next-line
      // state.workingHours = formatWorkingHours(storeState.company.openingDaysAndHours);
      checkWorkingHours();
    }
  },
  setWorkingHours(state, data) {
    // eslint-disable-next-line no-param-reassign
    state.workingHours = formatWorkingHours(data);
  },
  setTimeZone(state, data) {
    // eslint-disable-next-line no-param-reassign
    state.timeZone = data;
  },
};

const doubleDigit = (num, front = true) => {
  if (num.length === 1) {
    return front ? `0${num}` : `${num}0`;
  }
  return num;
};

const formatTime = (time) => {
  const [hours, minutes] = time.split(':');
  return `${doubleDigit(hours)}:${doubleDigit(minutes, false)}`;
};

// eslint-disable-next-line import/no-dynamic-require
const lang = require(`../../lang/${langGet()}/state`);

const chargespermile = () => {
  const distanceUnit = storeState.company.distanceUnit;
  const valuePerMile = distanceUnit === 'miles' ? storeState.company.deliveryCharges.chargesPerMile.toFixed(2) : (storeState.company.deliveryCharges.chargesPerMile / 1000).toFixed(2);
  return `<p>${distanceUnit === 'miles' ? lang.chargesPerMile : lang.chargesPerKm}: ${storeState.company.currencySymbol}${valuePerMile}</p>`;
};

const nodeliverycharges = () => `<p>${lang.noCharges}</p>`;

const chargesbymiles = () => {
  const distanceUnit = storeState.company.distanceUnit;
  const charges = storeState.company.deliveryCharges.chargesByMiles
    .sort((a, b) => parseFloat(a.fromMiles) - parseFloat(b.fromMiles))
    .map(current => `<p class="mb-0">${lang.from} ${distanceUnit === 'miles' ? current.fromMiles : (current.fromMiles / 1000).toFixed(2)} ${lang.to} ${distanceUnit === 'miles' ? current.toMiles : (current.toMiles / 1000).toFixed(2)} ${distanceUnit === 'miles' ? lang.miles : lang.km} = ${storeState.company.currencySymbol}${current.charges}</p>`);
  if (storeState.company.deliveryCharges.defaultCharges
    && storeState.company.deliveryCharges.defaultCharges !== 0) {
    charges.unshift(`<div>${lang.defaultCharges}: ${storeState.company.currencySymbol}${storeState.company.deliveryCharges.defaultCharges}</div>`);
  }
  charges.unshift(`<div>${distanceUnit === 'miles' ? lang.chargesByMiles : lang.chargesByKms}</div><br>`);
  return charges.join('');
};

const chargesbyinvoiceamount = () => {
  const charges = storeState.company.deliveryCharges.chargesByInvoiceAmt
    .sort((a, b) => parseFloat(a.fromAmount) - parseFloat(b.fromAmount))
    .map(current => `<p class="mb-0">${lang.from} ${storeState.company.currencySymbol}${current.fromAmount} ${lang.to} ${storeState.company.currencySymbol}${current.toAmount} = ${storeState.company.currencySymbol}${current.charges}</p>`);
  charges.unshift(`<p>${lang.chargesByInvoice}</p>`);
  return charges.join('');
};


const getters = {
  company() {
    return storeState.company;
  },
  companyActive() {
    return storeState.company ?
      storeState.company.webShopResourceStatus === 'active' :
      null;
  },
  closed() {
    return storeState.closed;
  },
  remainingWorkingRanges() {
    return storeState.remainingWorkingRanges;
  },
  closingMessage() {
    return storeState.message;
  },
  closedMessage() {
    return storeState.disableOrder;
  },
  timeZone() {
    return storeState.timeZone;
  },
  workingHours() {
    if (
      !storeState.company ||
      !storeState.company.openingDaysAndHours ||
      storeState.company.openingDaysAndHours.length === 0 ||
      !storeState.workingHours
    ) return '';
    const schedule = {};
    storeState.workingHours.forEach((range) => {
      const rangeObj = { start: range.start, end: range.end };
      if (!schedule[range.day]) {
        schedule[range.day] = [rangeObj];
      } else {
        schedule[range.day].push(rangeObj);
      }
    });
    let scheduleHTML = '';
    Object.keys(schedule).forEach((day) => {
      const ranges = schedule[day]
        .sort((a, b) =>
          parseInt(a.start.split(':').join(), 10) - parseInt(b.start.split(':').join(), 10))
        .map(range => `${formatTime(range.start)} - ${formatTime(range.end)}`)
        .join(` ${langGet() === 'en' ? 'and' : 'und'} `);
      scheduleHTML += `<p class="mb-0">${daysByLAng[day][langGet()]} ${ranges}</p>`;
    });
    checkWorkingHours();
    return scheduleHTML;
  },
  currentWorkingHours() {
    const workingHours = storeState.workingHours;
    const curretnDay = moment().isoWeekday();
    const today = days[curretnDay - 1].toUpperCase();
    return getHoursForDay(workingHours, today);
  },
  tomorrowsWorkingHours() {
    const workingHours = storeState.workingHours;
    const curretnDay = moment().isoWeekday();
    const tomorrow = days[curretnDay] ?
      days[curretnDay].toUpperCase() : days[0].toUpperCase();
    return getHoursForDay(workingHours, tomorrow);
  },
  deliveryCharges() {
    if (
      !storeState.company ||
      !storeState.company.deliveryCharges ||
      !storeState.company.deliveryCharges.type
    ) return '';
    switch (storeState.company.deliveryCharges.type) {
      case 'chargespermile': {
        return chargespermile();
      }
      case 'nodeliverycharges': {
        return nodeliverycharges();
      }
      case 'chargesbymiles': {
        return chargesbymiles();
      }
      case 'chargesbyinvoiceamount': {
        return chargesbyinvoiceamount();
      }
      default: {
        return '';
      }
    }
  },
};

const actions = {
  setCompany({ commit }, company) {
    // console.log(company);
    commit('setCompany', company);
  },
  setWorkingHours({ commit }, workingHours) {
    commit('setWorkingHours', workingHours);
  },
  setTimeZone({ commit }, timeZone) {
    commit('setTimeZone', timeZone);
  },
};

export default {
  state: storeState,
  mutations,
  getters,
  actions,
};



// WEBPACK FOOTER //
// ./src/store/modules/company.js